import * as React from 'react'

function SvgJm(props) {
	return (
		<svg viewBox="0 0 12 6" width="1em" height="1em" {...props}>
			<path fill="#009B3A" d="M0 0h12v6H0" />
			<path stroke="#FED100" d="M-6 9L18-3V9L-6-3" />
		</svg>
	)
}

export default SvgJm
